module.exports = __webpack_public_path__ + "assets/img/my-vip-cont1.1cdedf5a.png";